<template>
  <div id="app">
    <div class="demo-image__lazy">
      <el-image
        :preview-src-list="previewSrcList"
        v-for="url in urls"
        :key="url"
        :src="url"
        lazy
      ></el-image>
    </div>
    <div
      class="buttom-btn"
      v-if="!contract.resultFile"
      :style="{ bottom: bottom + 'px' }"
    >
      <el-button type="primary" @click="Sign">合同签署</el-button>
    </div>

    <!-- 弹框 -->
    <el-dialog
      v-loading="Loading"
      width="100%"
      top="45vh"
      title="合同签署"
      :visible.sync="centerDialogVisible"
      center
      @close="close"
    >
      <Sign ref="esign" @setsignin="setsignin" />
    </el-dialog>
  </div>
</template>

<script>
import Sign from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    Sign,
  },
  data() {
    return {
      deviceType: "",
      Loading: false,
      contract: {},
      centerDialogVisible: false,
      urls: [],
      bottom: 18,
      previewSrcList: {},
      apiUrlStings:'https://testapi.onlinenx.com',
      geturlsting:'',
      constructId:'',
      tenantId:''

    };
  },
  mounted() {
    this.geturl()

  },
  methods: {
    geturl(){
      this.geturlsting = window.location.href;
      // this.geturlsting = 'http://testsign.onlinenx.com/?id=797&tenantId=154'
      let getqyinfo = this.geturlsting.split("?")[1]
      let getqys = getqyinfo.split("&")
      this.constructId = getqys[0].split('=')[1]
      this.tenantId = getqys[1].split('=')[1]
      this.getStudentContract();
    },


    detectDeviceType() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        this.deviceType = "Windows Phone";
      } else if (/android/i.test(userAgent)) {
        this.deviceType = "Android";
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.deviceType = "iOS";
        this.bottom = 30;
      } else {
        this.deviceType = "Desktop";
        this.height = window.innerWidth / 2;
      }
    },
    close() {
      this.$refs.esign.handleReset();
    },
    Sign() {
      this.centerDialogVisible = true;
    },
    setsignin(signin) {
      this.signAgree(signin);
    },
    // 合同签署
    async signAgree(signin) {
      this.Loading = true;
      signin.append("contractId", this.contract.id);
      signin.append("filepath", this.contract.tempFile);
      // 定义请求选项，包括请求方法、Content-Type 等
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "tenant-id": this.tenantId,
        },
        body: signin,
      };

      // eslint-disable-next-line no-debugger
      try {
        // 发起 fetch 请求
        const response = await fetch(
          this.apiUrlStings+"/admin-api/crm/contract/signContract",
           options
        );
        // 检查响应状态
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        // 如果服务器返回 JSON 数据，可以进一步处理
        const data = await response.json();

        if (data.code == 0) {
          this.$message({
            message: "签署成功",
            type: "success",
          });
          this.Loading = false;
          this.centerDialogVisible = false;
          this.getStudentContract();
          this.$refs.esign.handleReset();

          // var jsonStr = data.data.picList;
          // if (jsonStr) {
          //   var imageUrlArray = JSON.parse(jsonStr);
          //   this.urls = imageUrlArray;
          //   this.previewSrcList = imageUrlArray;
          //   this.close();
          //   this.getStudentContract();
          // } else {
          //   this.close();
          //   this.getStudentContract();
          // }
        } else {
          this.Loading = false;
          this.$message({
            message: "签署失败",
            type: "error",
          });
          this.centerDialogVisible = false;
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    },
    // 获取学生合同
    getStudentContract() {
      //   const apiUrl = 'https://testapi.onlinenx.com/admin-api/crm/contract/getContractById';
      const apiUrl = this.apiUrlStings+"/admin-api/crm/contract/getContractById";
      const params = {
        id: this.constructId,
      };
      let options = {
        method: "GET", //post请求
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "tenant-id": this.tenantId,
        },
      };
      // 将参数对象转化为URL查询字符串
      const queryString = Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");

      // 拼接完整的请求URL
      const requestUrl = `${apiUrl}?${queryString}`;

      fetch(requestUrl, options)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          if (data.code === 500) {
            this.$message({
              message: data.msg,
              type: "error",
            });
          } else if (data.code === 0) {
            this.contract = data.data;
            var jsonStr = data.data.picList;
            if (data.data.picList) {
              var imageUrlArray = JSON.parse(jsonStr);
              this.urls = imageUrlArray;
              this.previewSrcList = imageUrlArray;
            } else {
              this.$message({
                message: "请先生成合同",
                type: "error",
              });
            }
          } else {
            this.$message({
              message: data.msg,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          // 在这里显示错误提示或执行其他错误处理逻辑
        });
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.el-dialog__body {
  padding: 0 !important;
}

.buttom-btn {
  position: fixed;

  width: 100%;
}
</style>
